// extracted by mini-css-extract-plugin
export default {"container":"LongSettings_container__LcgCy","divider":"LongSettings_divider__6LMGU"};